module.exports = __webpack_public_path__ + "img/zhenduan_pitchon.e40492e7.svg";